<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeProModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeProModal">
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 7"
             data-uk-tooltip="Закрыть"
             style="cursor: pointer;"
             @click="closeProModal">
          <md-icon>close</md-icon>
        </div>
        <div class="uk-modal-title">
          Описание про-ретушеров
        </div>
      </div>
      <div class="uk-modal-body">

        <div class="uk-margin">
          Минуты с знаком + или - считаются каждый час на 59 минуте по крону $schedule->command('calculate:proretoucher-employment')->hourlyAt(59) в очередях со смещением 1 час назад для надежности. На основе этих данные проставляются цвета для ячеек минут в батарейке - зеленые (успешно отработанные), красные (пропущенные) и серые (перерывы).
        </div>
        <div class="uk-margin">
          Расчет минут в очереди (батарейка)<br>
          Зависимости, или что может сломаться<br>
          1) Расчет минут для таблицы pro_retoucher_minute_employment<br>
          2) Изменение Quality в таблице schedule_calendar_pro по результатам п.1<br>
          3) Расчет зарплаты проретушера для таблицы temp_pro_retoucher_salary
        </div>
        <div class="uk-margin">
          <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
            <div class="uk-width-auto">
              <div class="tm-scheduletable-dropdown-list-cell uk-text-bold uk-text-small tm-scheduletable-dropdown-list-cell-bg-gray" style="padding: 5px;border-radius: 4px;margin: 3px;">
                XX:XX
              </div>
            </div>
            <div class="uk-width-expand">
              Перерыв про-ретушер может брать не более 2 раз за 8 часов (смена, записываются адмиом, 2 дня утр, 2 дня вечер, 2 дня ночная, 2 дня выходных) через час один от другог и нельзя вбрать в конце и в начале смены и только когда когда нет заказов (нет done-retouche done-admin-new) и если нет перерыва у другого ретушера в этот момент и равен 30 минутам
            </div>
          </div>
        </div>

        <div class="uk-margin-small">
          <md-icon class=”tm-scheduletable-pro-shift-bad” style="color: red !important;">cancel</md-icon> - пропущенная смена, если в батарейке менее 10 мин или была запись на смену, но нет выполненных заказов (без учета 30-минутных перерывов)
        </div>
        <div class="uk-margin-small">
          <md-icon class=”tm-scheduletable-pro-shift-unproductive” style="color: #ff9c1f !important;">thumb_down_alt</md-icon> - не продуктивно отработанная смена, если в батарейке менее 30 и есть подряд 20 мин пропуска (без учета 30-минутных перерывов)
        </div>
        <div class="uk-margin-small">
          <md-icon class=”tm-scheduletable-pro-shift-good” style="color: #4caf50 !important;">check_circle</md-icon> - успешно отработана смена, показываем в остальных случаях (без учета 30-минутных перерывов)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    closeProModal() {
      this.$emit('close');
    },
  },
  async created() {
  }
}
</script>